import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/typescript.png'


const _withScopeId = n => (_pushScopeId("data-v-23a9e416"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode("Typescript Transpiler")
], -1))
const _hoisted_2 = { class: "form-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Entry File", -1))
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Output Location", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "/" }, "/", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "text-center actions" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring lds-ring-small" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading ...", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "error-container"
}

import DefaultWorkspace from '@/components/composed/DefaultWorkspace'
import { ref } from 'vue'
import { TSTranspiler } from '@/core/TSTranspiler'
import * as ts from 'typescript'
import { createToast } from 'mosha-vue-toastify'
import * as rollup from 'rollup'


export default /*#__PURE__*/_defineComponent({
  __name: 'TranspileTSFile',
  props: {
  workspace: DefaultWorkspace
},
  setup(__props) {

const props = __props;



const loading = ref(false)
const selEntryFileLocation = ref('')
const selOutputLocation = ref('/')
const diagnostics = ref([])

async function compile(outDir: string, entryFile: string) {
  if (!entryFile) {
    createToast(`Please select a file!`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      })
    return
  }
  const compilerOptions = {
    noEmitOnError: true,
    strict: true,
    noImplicitOverride: true,
    target: ts.ScriptTarget.ES2015,
    module: ts.ModuleKind.ES2015,
    lib: [
      '/node_modules/typescript/lib.es2015.collection.d.ts',
      '/node_modules/typescript/lib.es2015.core.d.ts',
      '/node_modules/typescript/lib.es2015.generator.d.ts',
      '/node_modules/typescript/lib.es2015.iterable.d.ts',
      '/node_modules/typescript/lib.es2015.promise.d.ts',
      '/node_modules/typescript/lib.es2015.proxy.d.ts',
      '/node_modules/typescript/lib.es2015.reflect.d.ts',
      '/node_modules/typescript/lib.es2015.symbol.d.ts',
      '/node_modules/typescript/lib.es2015.symbol.wellknown.d.ts',
      '/node_modules/typescript/lib.es5.d.ts',
      '/node_modules/typescript/lib.es2016.array.include.d.ts',
      '/node_modules/typescript/lib.es2017.intl.d.ts',
      '/node_modules/typescript/lib.es2017.object.d.ts',
      '/node_modules/typescript/lib.es2017.sharedmemory.d.ts',
      '/node_modules/typescript/lib.es2017.string.d.ts',
      '/node_modules/typescript/lib.es2017.typedarrays.d.ts',
      '/node_modules/smartweave/contract-format.d.ts',
    ],
    outDir: '/',
    esModuleInterop: true,
    removeComments: true,
    checkJs: true,
    allowJs: true,
    allowUnreachableCode: false,
    exactOptionalPropertyTypes: true,
    noImplicitReturns: true,
    noImplicitThis: true,
    noImplicitAny: true
  };
  diagnostics.value = []
  const transpiler = new TSTranspiler(compilerOptions, props.workspace)
  const fileNames = [entryFile]
  loading.value = true

  try {
    diagnostics.value = transpiler.compile(fileNames)
    if (diagnostics.value.length) {
      throw new Error('Error on transpilation!');
    }
    createToast(`Success!`,
      {
        type: 'success',
        showIcon: true,
        position: 'bottom-right',
      });
  } catch(error) {
    createToast(`${error}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
  loading.value = false

  if (!diagnostics.value.length) {
    // Rollup
    const modules = transpiler.getModules()

    await roll(modules, entryFile, outDir)
    
  }
    //.then(bundle => bundle.generate({ format: 'es' }))
    //.then(({ output }) => console.log(output[0].code));
}


const loadNodeModulesToWorkspace = async () => {
  diagnostics.value = []
  loading.value = true

  // Add folders
  props.workspace.addFolder('/', 'node_modules')

  // Add typescript types
  try {
    await loadTypescriptLibs()
  } catch (error) {
    createToast(`${error}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }

  // Add smartweave types
  try {
    await loadSmartweave()
  } catch (error) {
    createToast(`${error}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
  
  // Add Verto Flex lib

  // Update loader
  loading.value = false
};


async function roll(
  modules: Record<string, string>,
  entryFile: string,
  outDir: string) {
  const myPlugin = () => {
    return {
      name: 'loader',
      resolveId: (source, importer, options) => {
        // TODO
        // Resolve ./, ../, ./../, etc
        if (Object.prototype.hasOwnProperty.call(modules, source)) {
          return source;
        }
      },
      load: (id) => {
        if (Object.prototype.hasOwnProperty.call(modules, id)) {
          return modules[id];
        }
      }
    }
  }
  // Start
  try {
    console.log('modules', modules)
    const fragments = entryFile.split('/')
    const fileName = fragments.splice(-1)[0]
    const inputEntryFile = fileName.replace('.ts', '')

    const bundle = await rollup.rollup({
        input: `./${inputEntryFile}`,
        plugins: [
          myPlugin()
        ]
      })

    const { output } = await bundle.generate({ format: 'es' })
    const finalBundle = output[0].code

    const date = new Date()
    const dateF = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`
    const finalBundleName = `bundle_${dateF}.js`

    const emptyEvent = new Event('empty')
    props.workspace.addEditor(
      emptyEvent,
      false,
      finalBundle,
      finalBundleName,
      outDir,
      false
    )

  } catch (error) {
    alert(error)
  }
}

async function loadTypescriptLibs() {
  const files = [
    'node-modules-sources/typescript/lib.es2015.collection.d.ts',
    'node-modules-sources/typescript/lib.es2015.core.d.ts',
    'node-modules-sources/typescript/lib.es2015.generator.d.ts',
    'node-modules-sources/typescript/lib.es2015.iterable.d.ts',
    'node-modules-sources/typescript/lib.es2015.promise.d.ts',
    'node-modules-sources/typescript/lib.es2015.proxy.d.ts',
    'node-modules-sources/typescript/lib.es2015.reflect.d.ts',
    'node-modules-sources/typescript/lib.es2015.symbol.d.ts',
    'node-modules-sources/typescript/lib.es2015.symbol.wellknown.d.ts',
    'node-modules-sources/typescript/lib.es5.d.ts',
    'node-modules-sources/typescript/lib.es2016.array.include.d.ts',
    'node-modules-sources/typescript/lib.es2017.intl.d.ts',
    'node-modules-sources/typescript/lib.es2017.object.d.ts',
    'node-modules-sources/typescript/lib.es2017.sharedmemory.d.ts',
    'node-modules-sources/typescript/lib.es2017.string.d.ts',
    'node-modules-sources/typescript/lib.es2017.typedarrays.d.ts',
  ]
  const path = '/node_modules/typescript/'
  const emptyEvent = new Event('empty')
  props.workspace.addFolder('/node_modules', 'typescript')

  for (const f of files) {
    const fileNameFragments = f.split('/')
    const fileName = fileNameFragments[fileNameFragments.length - 1]
    if (props.workspace.findFileIdByName(path, fileName) >= 0) {
      continue
    } else {
      let src = ''
      try {
        src = await downloadContent(f)
      } catch (error) {
        createToast(`Error downloading source file.`,
        {
          type: 'danger',
          showIcon: true,
          position: 'bottom-right',
        });
        // Skip rest of the code
        continue
      }
      props.workspace.addEditor(
        emptyEvent,
        false,
        src,
        fileName,
        '/node_modules/typescript',
        false)

    }
  }

}


async function loadSmartweave() {
  const files = [
    'node-modules-sources/smartweave/contract-format.d.ts',
  ]
  const path = '/node_modules/smartweave/'
  const emptyEvent = new Event('empty')
  props.workspace.addFolder('/node_modules', 'smartweave')

  for (const f of files) {
    const fileNameFragments = f.split('/')
    const fileName = fileNameFragments[fileNameFragments.length - 1]
    if (props.workspace.findFileIdByName(path, fileName) >= 0) {
      continue
    } else {
      let src = ''
      try {
        src = await downloadContent(f)
      } catch (error) {
        createToast(`Error downloading source file.`,
        {
          type: 'danger',
          showIcon: true,
          position: 'bottom-right',
        });
        // Skip rest of the code
        continue
      }
      props.workspace.addEditor(
        emptyEvent,
        false,
        src,
        fileName,
        '/node_modules/smartweave',
        false)

    }
  }

}

async function downloadContent(asset: string): string {
  const c = await fetch(asset)
  if (c && c.ok) {
    return c.text()
  }
  throw new Error(c.statusText)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("select", {
        disabled: loading.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selEntryFileLocation).value = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreeFilenames(), (path) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
            (path && path.search(/.ts$/) >= 0 && path.search(/node_modules/) < 0)
              ? (_openBlock(), _createElementBlock("option", {
                  key: 0,
                  value: path
                }, _toDisplayString(path), 9, _hoisted_5))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 8, _hoisted_4), [
        [
          _vModelSelect,
          selEntryFileLocation.value,
          void 0,
          { trim: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selOutputLocation).value = $event))
      }, [
        _hoisted_8,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreePaths(), (path) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
            (path && path.search(/node_modules/) < 0)
              ? (_openBlock(), _createElementBlock("option", {
                  key: 0,
                  value: path
                }, _toDisplayString(path), 9, _hoisted_9))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 512), [
        [
          _vModelSelect,
          selOutputLocation.value,
          void 0,
          { trim: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (compile(selOutputLocation.value, selEntryFileLocation.value)))
      }, " Compile "),
      _hoisted_11,
      _createElementVNode("button", {
        class: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (loadNodeModulesToWorkspace()))
      }, " Install node_modules dependencies ")
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
      : _createCommentVNode("", true),
    (diagnostics.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diagnostics.value, (d, index) => {
            return (_openBlock(), _createElementBlock("ul", { key: index }, [
              _createElementVNode("li", null, _toDisplayString(d), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})